// @ts-ignore - The file below is generated at build-time
import ApiRoutesFancy from './../routers/api-routes-fancy'

function mkUrl(subdomain: string) {
  return `https://${window.location.hostname.replace(/classroom|student|console|school|sso/, subdomain)}`
}

const API_URL = mkUrl('api')

const fancyPaths = ApiRoutesFancy.createPaths(API_URL)

export default {
  fancyPaths
}
